"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = (0, tslib_1.__importDefault)(require("graphql-tag"));
exports.default = (0, graphql_tag_1.default) `
  query getLocalSession {
    orionjsSession @client {
      _id
      publicKey
      secretKey
      createdAt
      userId
      locale
      roles
      emailVerified
      __typename
    }
  }
`;
